import React from "react";
import { Card, CardContent, Skeleton } from "@mui/material";
import Grid2 from "@mui/material/Grid2";

const ShippingCostSkeletonGrid = ({ count = 6 }) => (
    <Grid2 container spacing={2}>
        {[...Array(count)].map((_, index) => (
            <Grid2 key={index} xs={12} sm={6} md={4} lg={3}>
                <Card variant="outlined" sx={{ borderRadius: 3 }}>
                    <CardContent>
                        <Skeleton width="60%" />
                        <Skeleton width="30%" />
                        <Skeleton variant="rectangular" height={60} sx={{ mt: 1, borderRadius: 2 }} />
                    </CardContent>
                </Card>
            </Grid2>
        ))}
    </Grid2>
);

export default ShippingCostSkeletonGrid;
